import { IUserList } from 'sdi/source';
import { TableState } from 'sdi/components/table2';
import { Nullable } from 'sdi/util';
import { none } from 'fp-ts/lib/Option';

declare module 'sdi/shape' {
    export interface IShape {
        'data/users': IUserList;
        'component/table/title': Nullable<string>;
        'component/table': TableState;
    }
}

const defaultTableState = (): TableState => ({
    position: { x: 0, y: 0 },
    rowHeight: 19,
    columnAdjust: [-0.6, 0, 0, -0.2, 0, 0, 0, 0, 0, 0],
    selected: [],
    viewHeight: -1,
    window: { offset: 0, size: 100 },
    sort: none,
    filters: [],
});

export const defaultTableShape = () => ({
    'data/users': [],
    'component/table/title': null,
    'component/table': defaultTableState(),
});
